export const getLawyer = function getLawyer () {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  const params = new URLSearchParams(window.location.search)
  const slug = params.get('slug')
  const id = params.get('id')
  if (slug) return (root.lawyers || []).find(x => x.slug === slug)
  if (id) return (root.lawyers || []).find(x => x.id === id)
}

export const getFirmById = function getFirmById (firmId) {
  const s = this.getState ? this.getState() : this.state
  const root = s.root || s
  return (root.firms || []).find(f => f.id === firmId)
}
